import { Grid } from "@mui/material"

import { LinearLoading } from 'common'

export const InfoLawyerPayments = ({ useFetchInit }) => {
    const { FetchData, Forms } = useFetchInit
    const { fetchInfoProcessLawyer } = FetchData
    const { loadingFetchInfoProcessLawyer } = fetchInfoProcessLawyer
    const { FormScreen } = Forms
    const { formState } = FormScreen
    return (
        <>
            {(loadingFetchInfoProcessLawyer) && (<LinearLoading />)}
            {(formState.infoProcessLawyer.length > 0) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ marginBottom: 2, marginTop: 2 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>IDENTIFICADOR:</strong> {formState.infoProcessLawyer[0]?.process_number || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>CLIENTE:</strong> {formState.infoProcessLawyer[0]?.info_cliente || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>FECHA INICIO:</strong> {formState.infoProcessLawyer[0]?.date_start || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>COSTO DEL SERVICIO:</strong> Q {formState.infoProcessLawyer[0]?.initial_amount || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>CATEGORIA DE PROCESO:</strong> {formState.infoProcessLawyer[0]?.category_process || '' }
                            </span>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>PROCESO (JUZGADO):</strong> {formState.infoProcessLawyer[0]?.jdo_process_number || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>GASTOS EXTRAS:</strong> Q {formState.infoProcessLawyer[0]?.other_expense_total || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TOTAL A PAGAR:</strong> Q {formState.infoProcessLawyer[0]?.total_pagar || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>TOTAL RECIBIDO:</strong> Q {formState.infoProcessLawyer[0]?.total_recibido || '' }
                            </span>
                            <span style={{ fontSize: '1.1rem' }}>
                                <strong>SALDO:</strong> Q {formState.infoProcessLawyer[0]?.saldo_total || '' }
                            </span>
                        </div>
                    </Grid>
            </Grid>
            )}
        </>
    )
}
